// Phase 2 — extracted helper from Payouts.jsx so each tab can render the
// "Share" column with the same partner-model-aware formatting:
//
//   revenue_share    → % of gross commission (sharePct)
//   fixed_base_rate  → BPS of volume (shareValue × 10000) — the partner's
//                      ACTUAL rate, not their slice of gross
//   fixed_fee        → "Fixed fee" pill
//
// `partnerById` is the same memoized lookup the parent owns; passing it as
// an arg keeps this file pure (no module-global lookups).

import { fmtPct } from "@/lib/api";

export function makeShareFormatter(partnerById) {
  return function formatShare(partnerId, sharePct, shareValue) {
    if (!partnerId) return "—";
    const p = partnerById[partnerId] || {};
    const model = p.compensation_model || "fixed_base_rate";
    if (model === "revenue_share") return fmtPct(sharePct);
    if (model === "fixed_fee") {
      return <span className="text-[10px] text-[var(--muted)] uppercase tracking-wider">Fixed fee</span>;
    }
    const bps = Math.round((shareValue || 0) * 10000);
    return <span className="num">{bps} bps</span>;
  };
}
